import { createUseStyles } from 'react-jss'

import colors from 'src/config/colors'

export default createUseStyles({
  root: {
    fontSize: 12,
    fontFamily: 'Roboto',
    marginTop: 5,
    color: colors.guardsmanRed,
  },
})
